import type { JobHealth } from "@bigbear/shared";

const LABELS: Record<JobHealth, string> = {
  healthy: "Healthy",
  incomplete: "Incomplete",
  stale: "Overdue",
  failing: "Failing",
  "never-run": "Never run",
};

/**
 * Colour alone is not a signal — roughly one in twelve men cannot separate the
 * red and green here — so every state carries a distinct word too.
 */
export function HealthBadge({ health }: { health: JobHealth }) {
  return <span className={`badge badge--${health}`}>{LABELS[health]}</span>;
}
